"use strict";import{tag as r}from"../custom-tag.js";export function fileGenericIcon({height:e=16,width:l=16,hidden:a=!1,title:i="File generic"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${i}"
    >
      <g clip-path="url(#file-generic_svg__clip0_6875_6594)">
        <mask
          id="file-generic_svg__mask0_6875_6594"
          width="17"
          height="20"
          x="4"
          y="2"
          maskUnits="userSpaceOnUse"
          style="mask-type:alpha"
        >
          <path
            fill="currentColor"
            d="m20.253 7.146-5-5A.5.5 0 0 0 14.9 2h-9a1.5 1.5 0 0 0-1.5 1.5v17A1.5 1.5 0 0 0 5.9 22h13a1.5 1.5 0 0 0 1.5-1.5v-13a.5.5 0 0 0-.147-.354m-1.557-.143-3.283.012-.01-3.306zM19.4 20.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5h8.793l-.293.001.015 4.518a.5.5 0 0 0 .5.498h.002L19.4 8z"
          />
        </mask>
        <g mask="url(#file-generic_svg__mask0_6875_6594)">
          <path fill="currentColor" d="M24 0H0v24h24z" />
        </g>
      </g>
    </svg>
  `}
//# sourceMappingURL=fileGeneric.js.map
